import { Component } from 'react';
import PropTypes from 'prop-types';

class UsedVehiclesFiatV2Card extends Component {
  getTitle() {
    const { old_price } = this.props;

    if (old_price) {
      return `De ${this.formattedPrice(old_price)}`;
    }

    return 'Por apenas';
  }

  getSubtitle() {
    const { price, old_price } = this.props;

    if (old_price) {
      return `Por ${this.formattedPrice(price)}`;
    }

    return this.formattedPrice(price);
  }

  formattedPrice(price) {
    return `R$ ${price}`;
  }

  technicalItems() {
    const { km, exchange, fuelText } = this.props;
    const items = [
      {
        value: exchange,
        icon: 'transmission',
      },
      {
        value: km && `${km} KM`,
        icon: 'gauge',
      },
      {
        value: fuelText,
        icon: 'fuel-bomb',
      },
    ];

    return items;
  }

  render() {
    const {
      title,
      subtitle,
      badge,
      unit,
      image,
      link,
      old_price,
      mainImageLazy,
      icons,
    } = this.props;

    return (
      <div className="used-vehicle-card">
        <a className="used-vehicle-card__link" href={link}>
          <img
            className="used-vehicle-card__image"
            src={image}
            alt={title}
            width="200"
            height="145"
            loading={mainImageLazy ? 'lazy' : 'eager'}
          />
          <p className="used-vehicle-card__badge">{badge}</p>
        </a>
        <div className="used-vehicle-card__content">
          <h2 className="used-vehicle-card__unit">
            <img
              src={icons['map-pin']}
              className="used-vehicle-card__unit-icon"
              alt="Map Icon"
              width={18}
              height={18}
            />
            {unit}
          </h2>
          <h3
            className="used-vehicle-card__title"
            data-match-height="used-vehicle-card__title"
          >
            {title}
          </h3>
          <h4 className="used-vehicle-card__subtitle">{subtitle}</h4>
          <ul
            className="used-vehicle-card__highlights"
            data-match-height="used-vehicle-card__highlights"
          >
            {this.technicalItems().map(
              item =>
                !!item.value && (
                  <li className="used-vehicle-card__highlight">
                    <img
                      src={icons[item.icon]}
                      alt={`${item.icon} Icon`}
                      width={16}
                      height={16}
                    />
                    {item.value}
                  </li>
                ),
            )}
          </ul>
          <div className="used-vehicle-card__price">
            <p
              className={`used-vehicle-card__price-title ${
                old_price ? 'used-vehicle-card__price-title--line-through' : ''
              }`}
            >
              {this.getTitle()}
            </p>
            <p className="used-vehicle-card__price-value">
              {this.getSubtitle()}
            </p>
          </div>
          <a
            className="btn button button--primary used-vehicle-card__button"
            href={link}
          >
            Eu quero
          </a>
        </div>
      </div>
    );
  }
}

UsedVehiclesFiatV2Card.defaultProps = {
  title: '',
  subtitle: '',
  badge: '',
  unit: '',
  image: '',
  link: '',
  exchange: '',
  km: '',
  fuelText: '',
  price: '',
  old_price: '',
  mainImageLazy: false,
  icons: [],
};

UsedVehiclesFiatV2Card.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  badge: PropTypes.string,
  unit: PropTypes.string,
  image: PropTypes.string,
  link: PropTypes.string,
  exchange: PropTypes.string,
  km: PropTypes.string,
  fuelText: PropTypes.string,
  price: PropTypes.string,
  old_price: PropTypes.string,
  mainImageLazy: PropTypes.bool,
  icons: PropTypes.shape({
    'map-pin': PropTypes.string,
    transmission: PropTypes.string,
    gauge: PropTypes.string,
    'fuel-bomb': PropTypes.string,
  }),
};

export default UsedVehiclesFiatV2Card;
